var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.preview || _vm.model,
          expression: "!preview || model",
        },
      ],
    },
    [
      _c(
        "div",
        {
          staticClass: "questionnaireEditModuleHeader",
          attrs: { id: _vm.template.id },
        },
        [
          _c("label", { staticClass: "rbCheckbox" }, [
            _c("input", {
              staticClass: "rbCheckboxInput",
              attrs: {
                id: _vm.template.id,
                type: "checkbox",
                name: _vm.template.id,
              },
              domProps: { value: _vm.isSelected },
              on: {
                change: function ($event) {
                  return _vm.onChange($event.target.value)
                },
              },
            }),
            _c(
              "span",
              {
                staticClass:
                  "rbCheckboxLabel questionnaireEditModuleHeaderText",
                class: _vm.checkBoxClasses,
              },
              [_vm._v(" " + _vm._s(_vm.template.name) + " ")]
            ),
          ]),
        ]
      ),
      _c(
        "transition-group",
        { attrs: { tag: "div", name: "questionnaire-section" } },
        _vm._l(_vm.modelCells, function (cell) {
          return _c("questionnaire-edit-section", {
            key: cell.id,
            attrs: {
              config: _vm.config,
              model: _vm.getModel(cell.id),
              preview: _vm.preview,
              template: cell,
            },
            on: {
              questionAdded: _vm.addModuleAndForwardEvent,
              questionRemoved: _vm.addModuleAndForwardEvent,
              sectionAdded: _vm.addModuleAndForwardEvent,
              sectionRemoved: _vm.addModuleAndForwardEvent,
              questionRequiredChanged: _vm.addModuleAndForwardEvent,
              tableAdded: _vm.addModuleAndForwardEvent,
              tableRemoved: _vm.addModuleAndForwardEvent,
              tableConfigure: _vm.addModuleAndForwardEvent,
              userDefinedChanged: _vm.addModuleAndForwardEvent,
              userDefinedRemoved: _vm.addModuleAndForwardEvent,
              specialsChanged: _vm.addModuleAndForwardEvent,
            },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }